<article
  class="mx-auto flex h-full min-h-[662px] w-full max-w-[437px] flex-col rounded-xl border border-emerald-500 bg-surface-darker px-16 pt-16 pb-10 text-center shadow-sm"
>
  <div class="flex min-h-[204px] flex-col items-center">
    <h3
      class="w-full max-w-[294px] text-[30px] font-bold leading-[36px] tracking-[0.005em] text-white"
    >
      {{ planName() }}
    </h3>

    <div class="mt-7 flex min-h-[106px] flex-col items-center">
      <p
        class="min-h-6 text-[16px] font-medium leading-6 tracking-[0.005em] text-white"
        [class.invisible]="!pricePrefix()"
      >
        {{ pricePrefix() }}
      </p>
      <p class="text-[48px] font-bold leading-[58px] tracking-[0.005em] text-accent">
        {{ price() }}
      </p>
      <p
        class="min-h-6 text-[16px] font-medium leading-6 tracking-[0.005em] text-white"
        [class.invisible]="!priceSuffix()"
      >
        {{ priceSuffix() }}
      </p>
    </div>
  </div>

  <ul class="mt-4 min-h-[200px] w-full max-w-[304px] space-y-5 text-left">
    @for (feature of features(); track feature) {
      <li
        class="flex items-start gap-4 text-[20px] font-bold leading-6 tracking-[0.005em] text-[#E5E7EB]"
      >
        <span
          aria-hidden="true"
          class="inline-flex h-[26px] w-[26px] shrink-0 items-center justify-center rounded-full bg-teal-500 text-white"
        >
          <lucide-icon name="check" [size]="16"></lucide-icon>
        </span>
        <span>{{ feature }}</span>
      </li>
    }
  </ul>

  <div class="min-h-12 w-full max-w-[304px] self-center">
    <p
      class="w-full text-center font-mono text-[16px] font-normal leading-6 tracking-[0.005em] text-white"
    >
      {{ bestFor() }}
    </p>
  </div>

  @switch (actionMode()) {
    @case ('routerLink') {
      <a
        class="btn-primary mt-10 h-[46px] w-full max-w-[303px] self-center px-4 text-[15px] font-semibold leading-[18px]"
        [routerLink]="ctaRouterLink()!"
        [fragment]="ctaFragment() ?? undefined"
      >
        {{ ctaLabel() }}
      </a>
    }
    @case ('href') {
      <a
        class="btn-primary mt-10 h-[46px] w-full max-w-[303px] self-center px-4 text-[15px] font-semibold leading-[18px]"
        [href]="ctaHref()!"
      >
        {{ ctaLabel() }}
      </a>
    }
    @case ('static') {
      <span
        class="btn-primary pointer-events-none mt-6 h-[46px] w-full max-w-[303px] select-none self-center px-4 text-[15px] font-semibold leading-[18px]"
      >
        {{ ctaLabel() }}
      </span>
    }
  }
</article>
